<template>
  <div class="login-body">
    <div class="login-form">
      <el-form
        class="rule-LoginForm"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <h3 style="margin-top: 30px;">
          充电桩后台管理
        </h3>
        <el-form-item prop="userAccount">
          <el-input
            v-model="ruleForm.userAccount"
            placeholder="用户名"
            prefix-icon="icon icon-login_user"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            prefix-icon="icon icon-login_pass"
            placeholder="密码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit('ruleForm')"
            class="login-btn"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { setToken } from "../utils/auth.js";
var _self;
export default {
  data() {
    return {
      fullscreen: false,
      ruleForm: {
        userLogin: "",
        userPass: "",
        checked: false
      },
      rules: {
        userAccount: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        userPass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      isLogin: false
    };
  },
  created() {
    _self = this;
  },
  mounted() {},
  methods: {
    onSubmit(formName) {
      _self.$refs[formName].validate(valid => {
        if (valid) {
          if (!_self.isLogin) {
            _self.isLogin = true;
            //获取公钥
            api.userAPI
              .userKey({ account: _self.ruleForm.userAccount })
              .then(res => {
                if (res.status == 200) {
                  var encrypt = new _self.$jsencrypt();
                  encrypt.setPublicKey(res.data.publicKey);
                  _self.ruleForm.password = encrypt.encrypt(
                    _self.ruleForm.password
                  );
                  //进行登录
                  api.userAPI
                    .login({
                      account: _self.ruleForm.userAccount,
                      password: _self.ruleForm.password
                    })
                    .then(res => {
                      if (res.status == 200) {
                        window.sessionStorage.setItem(
                          "user",
                          JSON.stringify(res.data.userInfo)
                        );
                        setToken(res.data.user_token);
                        _self.$router.push("/PersonalManager");
                      } else {
                        _self.isLogin = false;
                        _self.$message.error(res.message);
                        _self.ruleForm.password = null;
                      }
                    });
                } else {
                  _self.$message({
                    message: res.message,
                    type: "error"
                  });
                }
              });
          }
        } else {
          _self.$message.error("验证不通过");
        }
      });
    }
  }
  // }
};
</script>
<style lang="scss" scoped></style>
